import React from 'react'

const Footer = () => {
  return (
    <div className='footer-bg w-full h-full'>
        <div className='py-8'>
            <p className='text-white text-center text-sm md:text-md lg:text-lg'>
             &copy; 2022 by Adlene Feliachi.&nbsp;
        </p>
        </div>
        
    </div>
  )
}

export default Footer